import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AddonsBreadShape from "../Assets/img/addons/addons-bred-shape.svg";
import AddonsBreadImg from "../Assets/img/addons/addons-breadcrumbs.png";
import AddonsData from "../Data/AddonsData.json";

const Addons = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <!-- Breadcrumbs --> */}
      <section className="breadcrumbs addons-bread">
        <div
          className="addons-bred-bg-img"
          style={{ backgroundImage: `url(${AddonsBreadShape})` }}
        ></div>
        <div className="container">
          <div className="row  align-items-center">
            {/* <!-- Breadcrumbs-Menu --> */}
            <div
              className="col-lg-5 col-md-6 col-12 wow fadeInLeft"
              data-wow-duration="2s"
            >
              <div className="breadcrumbs__content">
                <h2 className="breadcrumbs__title">ISP Digital Add-ons</h2>
                <p className="breadcrumbs__text">
                  By adding add-ons to ISP Digital, you will get additional
                  features. We are developing a lot of add-ons for ISP
                  industries which is growing their business.
                </p>
                <div className="addons-bred-btn">
                  <Link t0="/" className="theme-btn">
                    Browse add-ons
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 offset-lg-1 col-md-6 col-12 wow fadeInLeft"
              data-wow-duration="2s"
            >
              <div className="breadcrumbs__img">
                <img src={AddonsBreadImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Breadcrumbs --> */}

      {/* <!-- Addons area --> */}
      <section className="addons addons-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="addons__bar">
                <div className="addons__single-bar addons__search">
                  <form action="#" method="post" className="addons__form">
                    <input type="text" placeholder="Search add-ons" />
                    <div className="addons__button">
                      <a href="#" className="theme-btn addons__btn">
                        <i className="fa fa-search"></i>
                      </a>
                    </div>
                  </form>
                </div>
                <div className="addons_single-bar">
                  <div className="addons_single-list">
                    <div className="addons_single-price">
                      <h4>Price:</h4>
                      <ul>
                        <li>(৳) Taka</li>
                        <li className="active">($) USD</li>
                      </ul>
                    </div>
                    <div className="addons_single-price">
                      <h4>Sort:</h4>
                      <ul>
                        <li>Free items</li>
                        <li>Trending</li>
                        <li className="active">Paid items</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-12">
              <div className="addons__category">
                <h2 className="addons__title">Categories</h2>
                <ul>
                  <li>
                    Accounting <span>05</span>
                  </li>
                  <li>
                    Analytics <span>02</span>
                  </li>
                  <li>
                    CRM <span>01</span>
                  </li>
                  <li className="active">
                    E-commerce <span>10</span>
                  </li>
                  <li>
                    HR <span>05</span>
                  </li>
                  <li>
                    Support <span>05</span>
                  </li>
                  <li>
                    Import / Export<span>05</span>
                  </li>
                  <li>
                    Inventory<span>05</span>
                  </li>
                  <li>
                    Notification <span>05</span>
                  </li>
                  <li>
                    Marketing <span>05</span>
                  </li>
                  <li>
                    Payment method <span>05</span>
                  </li>
                  <li>
                    Report <span>05</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-9 col-12">
              <div className="row">
                {AddonsData.map((AddonsSingle) => (
                  <div
                    className="col-lg-4 col-md-6 col-12"
                    key={AddonsSingle.id}
                  >
                    <Link to="/addondetails">
                      <div className="addons__single">
                        {/* <!-- Addons Head --> */}
                        <div className="addons__head">
                          <div className="addons__img">
                            <img src={AddonsSingle.img} alt="#" />
                            <p className="addons__badge">
                              {AddonsSingle.addonsbadge}
                            </p>
                          </div>
                        </div>
                        {/* <!-- Addons Body --> */}
                        <div className="addons__body">
                          <div className="addons__content">
                            <h3 className="addons__price">
                              <span>{AddonsSingle.addonsprice}</span>{" "}
                              {AddonsSingle.addonsdurations}
                            </h3>
                          </div>
                          <h4 className="addons__single-title">
                            {AddonsSingle.title}
                          </h4>
                          <Link
                            className="addons__single-btn"
                            to="/addondetails"
                          >
                            Read more
                          </Link>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Addons area --> */}
    </>
  );
};

export default Addons;
